<template>
  <div :class="['header-wrapper', $route.query.header ? 'header-top' : '']">
    <div class="header">
      <div class="avatar" @click="toUser">
        <img :src="userInfo.avatar ?userInfo.avatar :defaultAvatar">
        <span>{{userInfo.name}}</span>
      </div>
      <div class="credit">
        <div @click="toCreditLog">
          <img src="../assets/icon/icons8-expensive_2@2x.png">
          <span>{{userInfo.credit ? userInfo.credit : 0}}</span>
        </div>
        <span @click="toExchangeLog" class="right-text">兑换记录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'top',
  data() {
    return {
      defaultAvatar: require('../assets/img/img_default_avatar.png')
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
  },
  methods: {
    toUser() {
      this.$router.push({ path: '/user' })
    },
    /**
     * 去积分记录
     */
    toCreditLog() {
      this.$router.push({ path: '/user/credit/log' })
    },

    /**
     * 去兑换记录
     */
    toExchangeLog() {
      this.$router.push({ path: '/user/exchange/log' })
      // this.$router.push({ path: '/user/sign' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/const.scss';
.header-wrapper{
  width: 100%;
  max-width: 768px;
  height: 55px;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  z-index: 100;
  .header{
    width: 345px;
    height: 50px;
    padding: 0 5px;
    border-radius: 0 0 5px 5px;
    background-color: #0d2e52;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .avatar{
      display: flex;
      align-items: center;
      img{
        width: 30px;
        height: 30px;
        border-radius: 15px;
        margin: 0 10px;
      }
      span{
        color: #ffffff;
        font-size: 12px;
        font-weight: 600;
      }
    }
    .credit{
      display: flex;
      align-items: center;
      div{
        display: flex;
        align-items: center;
        margin: 0 35px;
        img{
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
      }
      span {
        color: #ffffff;
        font-size: 12px;
        font-weight: 400;
      }
      .right-text {
        width: 67px;
      }
    }
  }
}
.header-top {
  top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue